import { render } from "./vserviceuser.vue?vue&type=template&id=2058f161&scoped=true"
import script from "./vserviceuser.vue?vue&type=script&lang=js"
export * from "./vserviceuser.vue?vue&type=script&lang=js"

import "./vserviceuser.vue?vue&type=style&index=0&id=2058f161&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2058f161"]])

export default __exports__